import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import bindPendingReferral from '../utils/referralBind';

const GOLD = '#B8892A';

export default function WxCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code) {
      setStatus('error');
      setErrMsg('未获取到授权码，请重新登录');
      return;
    }

    // Verify state to prevent CSRF
    const savedState = sessionStorage.getItem('wx_oauth_state');
    if (savedState && state !== savedState) {
      setStatus('error');
      setErrMsg('授权状态验证失败，请重新登录');
      return;
    }
    sessionStorage.removeItem('wx_oauth_state');

    // Exchange code for token
    (async () => {
      try {
        const { data } = await api.post('/auth/wx-h5-login', { code });
        // Save token and user info
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        bindPendingReferral(); // 微信注册不走注册表单,短链归因在此补绑(异步不阻塞)
        await refreshUser();
        setStatus('success');
        setTimeout(() => {
          navigate('/auction-hub', { replace: true });
        }, 800);
      } catch (err) {
        setStatus('error');
        setErrMsg(err?.response?.data?.error || '微信登录失败，请稍后重试');
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: '#FAFAF8', padding: 20,
    }}>
      <div style={{
        width: 48, height: 48, borderRadius: 8, background: '#8C1F1F',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#F5E6D0', fontSize: 14, fontWeight: 700, lineHeight: 1.1,
        textAlign: 'center', letterSpacing: 1, marginBottom: 20,
      }}>
        {'云川\n中古'}
      </div>

      {status === 'loading' && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 36, height: 36, border: '3px solid #E8E0D0',
            borderTopColor: GOLD, borderRadius: '50%',
            animation: 'spin 0.8s linear infinite', margin: '0 auto 16px',
          }} />
          <div style={{ fontSize: 15, color: '#110E0A', fontWeight: 500 }}>微信授权登录中...</div>
          <div style={{ fontSize: 12, color: '#A8998A', marginTop: 6 }}>请稍候</div>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      {status === 'success' && (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>&#10003;</div>
          <div style={{ fontSize: 15, color: '#2A6645', fontWeight: 500 }}>登录成功</div>
          <div style={{ fontSize: 12, color: '#A8998A', marginTop: 6 }}>正在跳转...</div>
        </div>
      )}

      {status === 'error' && (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>&#9888;</div>
          <div style={{ fontSize: 15, color: '#9B2335', fontWeight: 500, marginBottom: 8 }}>{errMsg}</div>
          <button onClick={() => navigate('/login', { replace: true })} style={{
            padding: '10px 32px', background: GOLD, border: 'none', borderRadius: 3,
            color: '#fff', fontSize: 14, cursor: 'pointer', marginTop: 12,
          }}>
            返回登录
          </button>
        </div>
      )}
    </div>
  );
}
